import floatMenu from './float-menu';

$(document).ready(function () {
    floatMenu();
});

var page = promokit.page({
    caution: '#section-caution',
    game: 'bns',
    menu: true,
    cnb: true,
    topButton: true,

    headerButton: {
        el: '.header-button',
        home: true,
        event:true,
        sns: true,
    },

    footer: {
        theme:'black'
    },
});


var layer1 = promokit.layer({
    el: '#layer-1',
    buttons: '.btn-layer1',
    render: true
});

var layer2 = promokit.layer({
    el: '#layer-2',
    buttons: '.btn-layer2',
    render: true
});

var layer3 = promokit.layer({
    el: '#layer-3',
    buttons: '.btn-layer3',
    render: true
});



// WEBPACK FOOTER //
// ./src/js/index.js